'use strict';

window.slate = window.slate || {};
window.theme = window.theme || {};

// Slate
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */
/* eslint-disable */
slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function pageLinkFocus($element) {
    var focusClass = 'js-focus-hidden';

    $element.first().attr('tabIndex', '-1').focus().addClass(focusClass).one('blur', callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function focusHash() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function bindInPageLinks() {
    $('a[href*=#]').on('click', function (evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function trapFocus(options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function removeTrapFocus(options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};
/* eslint-enable */

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */
/* eslint-disable */
slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function cookiesEnabled() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }
    return cookieEnabled;
  }
};
/* eslint-enable */

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */
/* eslint-disable */
slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function findInstance(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function removeInstance(array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function compact(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }
};
/* eslint-enable */

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */
/* eslint-disable */
slate.rte = {

  wrapTable: function wrapTable() {
    var rteTables = document.querySelectorAll('.rte table');
    rteTables.forEach(function (el) {
      var tableWrapper = document.createElement('div'); // create wrapper container
      tableWrapper.classList.add('rte__table-wrapper');
      el.parentNode.insertBefore(tableWrapper, el); // insert wrapper before el in the DOM tree
      tableWrapper.appendChild(el); // move el into wrapper
    });
  },

  iframeReset: function iframeReset() {
    var $iframeVideos = document.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');

    $iframeVideos.forEach(function (el) {
      var videoWrapper = document.createElement('div'); // create wrapper container
      videoWrapper.classList.add('rte__video-wrapper');
      el.parentNode.insertBefore(videoWrapper, el); // insert wrapper before el in the DOM tree
      videoWrapper.appendChild(el); // move el into wrapper
    });
  }
};
/* eslint-enable */

/* eslint-disable */
slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:section:reorder', this._onReorder.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function _createInstance(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function _onSectionLoad(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function _onSectionUnload(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function _onSelect(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function _onDeselect(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function _onReorder(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function _onBlockSelect(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function _onBlockDeselect(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function register(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function (index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});
/* eslint-enable */

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */
/* eslint-disable */
slate.Currency = function () {
  /* eslint-disable */
  var moneyFormat = '${{amount}}';
  /* eslint-enable */

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
}();
/* eslint-enable */

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */
/* eslint-disable */
slate.Image = function () {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    /* eslint-disable */
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
    /* eslint-enable */

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
}();
/* eslint-enable */

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */
/* eslint-disable */
slate.Variants = function () {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function _getCurrentOptions() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function _getVariantFromOptions() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function _onSelectChange() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function _updateImages(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function _updatePrice(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function _updateHistoryState(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function _updateMasterSelect(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
}();
/* eslint-enable */

// Components
theme.Search = new Vue({

  el: '.search',

  data: {
    isVisible: false,
    input: null,
    header: null,
    searchBtn: null,
    query: '',
    results: [],
    matches: []
  },

  /**
   * Fired when the app is ready
   */
  mounted: function mounted() {
    // Some DOM elements
    this.input = this.$el.querySelector('.search__input');
    this.header = document.querySelector('.header');
    this.searchBtn = this.header.querySelector('.header__btn--search');
    this.mainContent = document.querySelector('#MainContent');

    // Need to get reference to event handler functions so we can remove them later
    this.boundKeyHandler = this.keyHandler.bind(this);
    this.boundClickHandler = this.clickHandler.bind(this);
  },

  watch: {

    /**
     * When the query is 3 chars or longer fetch the search results
     */
    query: function query() {
      if (this.query.length > 1) {
        this.findMatches();
      } else {
        this.matches = [];
      }
    }
  },

  methods: {

    /**
     * Toggles the search modal
     */
    toggleModal: function toggleModal() {
      if (this.isVisible) {
        this.hideModal();
      } else {
        this.showModal();
      }
    },

    /**
     * Expands the search modal
     */
    showModal: function showModal() {
      document.body.classList.add('search-is-visible');
      this.isVisible = true;
      this.input.focus();
      // Close on ESC pressed
      window.addEventListener('keydown', this.boundKeyHandler);
      // Close on content clicked
      this.mainContent.addEventListener('click', this.boundClickHandler);

      if (!this.results.products) {
        this.fetchResults();
      }
    },

    /**
     * Collapses the search modal
     */
    hideModal: function hideModal() {
      document.body.classList.remove('search-is-visible');

      // Focus on the closing action element
      if (document.activeElement) {
        document.activeElement.focus();
      } else {
        this.searchBtn.focus();
      }

      // Reset data
      this.query = '';
      this.results = [];
      this.isVisible = false;
    },

    /**
     * Handles the esc key event
     */
    keyHandler: function keyHandler(event) {
      switch (event.key) {
        case 'Escape':
          window.removeEventListener('keydown', this.boundKeyHandler);
          this.hideModal();
          break;
      }
    },

    /**
     * Handles #MainContent click event
     */
    clickHandler: function clickHandler() {
      this.mainContent.removeEventListener('keydown', this.boundClickHandler);
      this.hideModal();
    },

    /**
     * Hit the alternative search template that returns json
     */
    fetchResults: function fetchResults() {
      var url = '/collections/all?view=all';
      $.get(url, this.onResultsFetched.bind(this));
    },

    /**
     * The search results
     * @param  {string} response The json string of search results
     */
    onResultsFetched: function onResultsFetched(response) {
      var data = JSON.parse(response);
      this.results = data;
    },

    /**
     * Wittles down the results array to match the query
     * @param  {string} query The query string
     */
    findMatches: function findMatches() {
      var query = this.query.split(' ').join('|');
      var regex = new RegExp('(' + query + ')', 'ig');

      this.matches = this.results.filter(function (result) {
        return result.title.search(regex) > -1 || result.content.search(regex) > -1;
      });
    },

    /**
     * Highlights the query text
     */
    highlightQueryTitle: function highlightQueryTitle(text) {
      var query = this.query.split(' ').join('|');
      var regex = new RegExp('(' + query + ')', 'ig');
      return text.replace(regex, '<mark>$1</mark>');
    },


    /**
     * Highlights the query text and truncates to 120 characters
     */
    highlightQueryContent: function highlightQueryContent(text) {
      var query = this.query.split(' ').join('|');
      var regex = new RegExp('(' + query + ')', 'ig');

      var index = text.search(regex) - 20;
      var start = index < 0 ? 0 : index;
      var shortenedText = text.substr(start, 120);

      return shortenedText.replace(regex, '<mark>$1</mark>');
    },


    /**
     * Get the image resource URL from the search results or return the default grey square.
     * @param  {object} result The result item object as returned from fetchResults
     * @return {string}        The URL to the image resource
     */
    getImage: function getImage(item) {
      return item.image ? slate.Image.getSizedImageUrl(item.image, '50x') : theme.assetUrl + 'placeholder-portrait.svg';
    }
  }
});

theme.AccordionList = function () {

  /**
   * Constructor
   */
  function AccordionList(container) {
    var _this = this;

    if (container.dataset.inited) {
      return;
    }
    // Public vars
    this.container = container;
    this.showingId = null;

    // Add click listeners to each button
    var buttons = this.container.querySelectorAll('.accordion__label button');
    buttons.forEach(function (el) {
      return el.addEventListener('click', _this.toggleBody.bind(_this));
    });

    container.dataset.inited = true;
  }

  /**
   * Event handler - decides what to show or hide
   */
  AccordionList.prototype.toggleBody = function (event) {

    var bodyId = event.currentTarget.dataset.toggle;
    var body = this.container.querySelector('#' + bodyId);

    // Is something showing?
    if (this.showingId) {
      // Is that something showing the same as what got clicked?
      if (this.showingId === bodyId) {
        this.hideBody(body);
      } else {
        var showingBody = this.container.querySelector('#' + this.showingId);
        this.hideBody(showingBody);
        this.showBody(body);
      }
    } else {
      this.showBody(body);
    }
  };

  /**
   * Event handler - shows a panel body
   */
  AccordionList.prototype.showBody = function (body) {
    body.parentElement.classList.add('is-expanded');
    this.showingId = body.id;
  };

  /**
   * Event handler - hides a panel body
   */
  AccordionList.prototype.hideBody = function (body) {
    body.parentElement.classList.remove('is-expanded');
    this.showingId = null;
  };

  return AccordionList;
}();

theme.QuantitySelector = function () {

  /**
   * Constructor
   */
  function QuantitySelector(container) {
    if (container.dataset.inited) {
      return;
    }
    // The elements
    this.input = container.querySelector('input');
    this.minus = container.querySelector('.quantity-selector__control--minus');
    this.plus = container.querySelector('.quantity-selector__control--plus');

    // The values
    this.min = parseInt(this.input.getAttribute('min'), 10);
    this.max = parseInt(this.input.getAttribute('max'), 10);

    // The listeners
    this.minus.addEventListener('click', this.decrement.bind(this));
    this.plus.addEventListener('click', this.increment.bind(this));

    // Are we already at the min or max?
    var quantity = parseInt(this.input.value, 10);

    if (quantity <= this.min) {
      this.minus.setAttribute('disabled', 'disabled');
    }

    if (quantity >= this.max) {
      this.plus.setAttribute('disabled', 'disabled');
    }

    this.onInputUpdated();

    container.dataset.inited = true;
  }

  /**
   * The minus click handler
   */
  QuantitySelector.prototype.decrement = function () {
    var quantity = parseInt(this.input.value, 10) - 1;
    this.input.value = quantity;
    this.onInputUpdated();
  };

  /**
   * The plus click handler
   */
  QuantitySelector.prototype.increment = function () {
    var quantity = parseInt(this.input.value, 10) + 1;
    this.input.value = quantity;
    this.onInputUpdated();
  };

  /**
   * Triggers an input event because input doesn't by default using js
   */
  QuantitySelector.prototype.onInputUpdated = function () {
    // Update availability of inputs
    var quantity = parseInt(this.input.value, 10);

    if (quantity >= this.max) {
      this.plus.setAttribute('disabled', 'disabled');
    } else {
      this.plus.removeAttribute('disabled');
    }

    if (quantity <= this.min) {
      this.minus.setAttribute('disabled', 'disabled');
    } else {
      this.minus.removeAttribute('disabled');
    }

    // Trigger input event
    var event = document.createEvent('HTMLEvents');
    event.initEvent('input', false, true);
    this.input.dispatchEvent(event);
  };

  return QuantitySelector;
}();

theme.ProductCard = function () {

  /**
   * Constructor
   */
  function ProductCard(container) {
    if (container.dataset.inited) {
      return;
    }

    // Public vars
    this.container = container;
    this.img = this.container.querySelector('img');

    if (this.img.dataset.src) {
      this.loadImage(this.img.dataset.src);
    }

    container.dataset.inited = true;
  }

  /**
   * Loads in the higher res image and swaps out the src
   */
  ProductCard.prototype.loadImage = function (src) {

    var image = new Image();
    var self = this;

    image.addEventListener('load', function () {
      self.imageLoadedHandler();
    });

    image.addEventListener('error', function () {
      self.imageLoadedHandler();
    });

    image.src = src;

    if (image.complete) {
      this.imageLoadedHandler();
    }
  };

  /**
   *
   */
  ProductCard.prototype.imageLoadedHandler = function () {
    this.img.src = this.img.dataset.src;
    this.container.classList.remove('not-loaded');
  };

  /**
   * Destroys the component
   */
  ProductCard.prototype.destroy = function () {
    if (!this.container) {
      return;
    }

    this.img.src = '';
    this.container.removeAttribute('data-inited');
    this.container.classList.add('not-loaded');
  };

  return ProductCard;
}();

theme.sideCart = new Vue({

  el: '.side-cart',

  data: {
    cart: null,
    timeout: null,
    isVisible: false,
    isReady: false,
    difference: 0,
    errorMessage: '',
    quantitySelectors: []
  },

  /**
   * Scripts to run when the app is ready
   */
  mounted: function mounted() {
    var _this2 = this;

    var json = document.querySelector('[data-side-cart-json]');

    if (!json) {
      console.error('Could not find data for the side cart');
      return;
    }

    this.cart = JSON.parse(json.innerHTML);

    var cartToggle = document.querySelectorAll('[data-toggle-cart]');
    cartToggle.forEach(function (el) {
      return el.addEventListener('click', _this2.toggleDrawer.bind(_this2));
    });

    this.updateDifference();

    this.isReady = true;
  },

  /**
   * Called when the vue instance data has changed
   */
  updated: function updated() {
    var self = this;

    // Trigger a value update
    this.quantitySelectors.forEach(function (selector) {
      return selector.onInputUpdated();
    });

    // Instantiate components automatically
    document.querySelectorAll('[data-component=QuantitySelector]').forEach(function (el) {
      if (!el.dataset.inited) {
        self.quantitySelectors.push(new theme[el.dataset.component](el));
      }
    });
  },

  watch: {

    /**
     * Update the count and total when an item's data is updated
     */
    cart: {
      handler: function handler() {
        var items = this.cart.items;
        var length = items.length;

        var count = 0;
        var total = 0;

        for (var i = 0; i < length; i++) {
          // Add up count and total
          count += items[i].quantity;
          total += items[i].quantity * items[i].price;
        }

        /* eslint-disable */
        this.cart.item_count = count;
        this.cart.total_price = total;
        /* eslint-enable */

        // Update the cart when the user stops clicking furiously
        clearTimeout(this.timeout);
        this.timeout = setTimeout(this.updateCart.bind(this), 500);
      },
      // Needed for nested object
      deep: true
    }
  },

  methods: {

    /**
     * Toggles the cart drawer
     */
    toggleDrawer: function toggleDrawer(event) {
      if (event) {
        event.preventDefault();
      }

      if (this.isVisible) {
        this.closeDrawer(event);
      } else {
        this.openDrawer(event);
      }
    },

    /**
     * Opens the cart drawer
     * @todo trap focus
     */
    openDrawer: function openDrawer(event) {
      // Capture focus
      this.opener = document.activeElement;

      if (event) {
        event.preventDefault();
      }
      document.body.classList.add('cart-is-visible');
      this.isVisible = true;

      // Set focus
      this.$el.querySelector('.side-cart__close').focus();
    },

    /**
     * Closes the cart drawer
     */
    closeDrawer: function closeDrawer(event) {
      if (event) {
        event.preventDefault();
      }

      document.body.classList.remove('cart-is-visible');
      this.isVisible = false;
      this.errorMessage = '';

      // Set focus back to opener
      if (this.opener) {
        this.opener.focus();
      }
    },

    /**
     * Post the new data to the cart
     */
    updateCart: function updateCart() {

      var self = this;
      // Clone the array so we can splice it later
      var items = this.cart.items.slice(0);
      var length = items.length;
      var data = {};

      for (var i = 0; i < length; i++) {
        data[items[i].id] = items[i].quantity;

        // Check for an empty item and remove from the cart data
        if (items[i].quantity <= 0) {
          this.cart.items.splice(i, 1);
        }
      }

      // No data was changed so return early
      if (JSON.stringify(data) === JSON.stringify(this.cache)) {
        return;
      }

      this.updateDifference();

      this.cache = data;

      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: { updates: data },
        dataType: 'JSON',
        success: function success() {
          self.errorMessage = '';
        },
        error: function error(response) {
          self.errorMessage = response.responseJSON.description;
        }
      });

      this.onCartUpdated();
    },

    /**
     * The success callback
     */
    onCartUpdated: function onCartUpdated() {
      var headerCount = document.querySelector('.header__cart-count');
      var bagEmpty = document.querySelector('.bag-icon-empty');
      var bagFull = document.querySelector('.bag-icon-full');

      if (this.cart.item_count > 0) {
        headerCount.classList.remove('hide');
        bagEmpty.classList.add('hide');
        bagFull.classList.remove('hide');
      } else {
        headerCount.classList.add('hide');
        bagEmpty.classList.remove('hide');
        bagFull.classList.add('hide');
        // Close the drawer if there's no items left in the cart
        this.closeDrawer();
      }
      headerCount.innerHTML = this.cart.item_count;
      this.refreshCart();
    },

    /**
     * Add an item to the cart
     * @param {object} item - The item being added to the cart
     * @param {number} item.id - The variant id
     * @param {number} item.quantity - The amount of that item you're adding
     * @param {number} item.price - The price of the item
     * @param {string} item.title - The product title
     * @param {string} item.description - The item description (usually the variant title)
     * @param {string} item.url - The url to the product and variant
     * @param {string} item.image - The image of the variant or product
     * @param {object} item.properties - Any line item properties for the cart
     * @param {number} item.min - The minimum amount of this item allowed in the cart (usually 0)
     * @param {number} item.max - The maximum amount of this item allowed in the cart
     */
    addItem: function addItem(item) {
      // Is this item in the cart already?
      for (var i = 0, length = this.cart.items.length; i < length; i++) {
        if (this.cart.items[i].id === item.id) {
          // Is there stock?
          if (this.cart.items[i].quantity + item.quantity > item.max) {
            this.errorMessage = 'There is no more stock for that item.';
            return;
          }

          this.cart.items[i].quantity += item.quantity;
          this.errorMessage = '';
          return;
        }
      }

      // Is there stock?
      if (item.quantity > item.max) {
        this.errorMessage = 'There is no more stock for that item.';
        return;
      }

      this.cart.items.unshift(item);
      this.errorMessage = '';

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          id: item.id,
          quantity: item.quantity,
          properties: item.properties
        },
        dataType: 'JSON',
        error: function error(response) {
          console.error('Error updating cart:', response);
        }
      });
    },

    /**
     * Remove item from cart
     */
    removeItem: function removeItem(item) {
      for (var i = 0, length = this.cart.items.length; i < length; i++) {
        if (this.cart.items[i].id === item.id) {
          this.cart.items[i].quantity = 0;
          break;
        }
      }
    },

    /**
     * Refreshes the cart data
     */
    refreshCart: function refreshCart() {
      var self = this;

      $.get('/cart?view=json', function (response) {
        self.data = JSON.parse(response);
      });
    },

    /**
     * Format cents into dollars
     */
    updateDifference: function updateDifference() {
      var _this3 = this;

      if (!theme.settings.offer_enable) {
        return;
      }

      var self = this;
      var threshold = Number(theme.settings.offer_threshold);
      var difference = threshold - this.cart.total_price / 100;
      var offer = this.cart.items.find(function (item) {
        return item.properties && item.properties._offer;
      });

      if (offer) {
        if (difference > 0) {
          // Remove offer item from cart
          this.removeItem(offer);
          this.difference = difference;
        }
      } else if (!offer && difference < 1) {
        $.getJSON('/products/' + theme.settings.offer_product + '.js', function (response) {

          if (response.available) {
            self.addItem({
              id: response.variants[0].id,
              quantity: 1,
              price: 0,
              title: response.title,
              url: response.title,
              image: response.featured_image,
              properties: {
                _offer: true
              },
              min: 1,
              max: 1
            });
          } else {
            console.error('Cart error: The offer item', response.title, 'is unavailable.');
          }

          _this3.difference = difference;
        });
      } else {
        this.difference = difference;
      }
    },

    /**
     * Format cents into dollars
     */
    itemImage: function itemImage(image) {
      var src = theme.assetUrl + 'placeholder-portrait.svg';
      if (image) {
        if (image.src) {
          src = image.src;
        } else {
          src = image;
        }
      }
      return slate.Image.getSizedImageUrl(src, '200x200_crop_center');
    },

    /**
     * Format cents into dollars
     */
    formatMoney: function formatMoney(price) {
      return slate.Currency.formatMoney(price, theme.moneyFormat);
    }

  }

});

// TO DO
// These are for the style guide examples only, create a new js select element for each custom select

// var select1 = new CustomSelect({
//   elem: "border-select",
// });

// var select2 = new CustomSelect({
//   elem: "no-border-select",
// });


// Sections
theme.Header = function () {

  /**
   * Constructor
   * @todo instantiate outside of slate so we have access to public methods
   */
  function Header(container) {

    this.isFixed = false;
    this.header = container.querySelector('.header');

    var self = this;

    // Menu toggle
    var btnMenuOpen = container.querySelector('.hamburger--open');
    btnMenuOpen.addEventListener('click', this.btnMenuClickOpenHandler);

    // Search toggle
    var btnSearch = container.querySelector('.header__btn--search');
    btnSearch.addEventListener('click', function () {
      theme.Search.toggleModal();
      self.collapseDropdown();
    });

    var navLinks = container.querySelectorAll('.nav__item--toggle');
    navLinks.forEach(function (el) {
      el.addEventListener('click', self.navLinkClickHandler.bind(self));
    });

    var subNavLinks = container.querySelectorAll('.subnav__item--toggle');
    subNavLinks.forEach(function (el) {
      el.addEventListener('click', self.subNavLinkClickHandler.bind(self));
    });
  }

  /**
   * Click handler for search button
   */
  Header.prototype.collapseDropdown = function () {
    var activeDropdowns = this.header.querySelectorAll('.nav__item.has-child.is-expanded');
    activeDropdowns.forEach(function (el) {
      if (el) {
        el.classList.remove('is-expanded');
      }
    });
  };

  /**
   * .header__btn--menu click handler
   */
  Header.prototype.btnMenuClickOpenHandler = function () {
    document.body.classList.toggle('menu-is-expanded');
    document.body.classList.toggle('menu-not-expanded');
  };

  /**
   * .nav__item.has-child > a click handler
   */
  Header.prototype.navLinkClickHandler = function (event) {

    var clientWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    var navItem = event.currentTarget.parentElement;

    if (clientWidth >= Number(theme.settings.grid_large) && navItem.classList.contains('has-hover')) {
      return false;
    }

    // Hide the search modal if it's showing
    if (theme.Search && theme.Search.isVisible) {
      theme.Search.hideModal();
    }

    // Menu item toggle
    var navLinks = document.querySelectorAll('.nav__item--toggle');

    event.preventDefault();

    // event.target.parentElement.classList.toggle('is-expanded');
    if (navItem.classList.contains('is-expanded')) {
      navItem.classList.remove('is-expanded');
      document.body.classList.remove('dropdown-is-active');
    } else {
      navLinks.forEach(function (el) {
        return el.parentElement.classList.remove('is-expanded');
      });
      navItem.classList.add('is-expanded');
      document.body.classList.add('dropdown-is-active');
    }

    return true;
  };

  /**
   * .subnav__item.has-child > a click handler
   */
  Header.prototype.subNavLinkClickHandler = function (event) {

    var clientWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    var subNavItem = event.currentTarget.parentElement;

    if (clientWidth >= Number(theme.settings.grid_large) && subNavItem.classList.contains('has-hover')) {
      return false;
    }

    // Menu item toggle
    var subNavLinks = document.querySelectorAll('.subnav__item--toggle');

    event.preventDefault();

    // event.target.parentElement.classList.toggle('is-expanded');
    if (subNavItem.classList.contains('is-expanded')) {
      subNavItem.classList.remove('is-expanded');
    } else {
      subNavLinks.forEach(function (el) {
        return el.parentElement.classList.remove('is-expanded');
      });
      subNavItem.classList.add('is-expanded');
    }

    return true;
  };

  return Header;
}();

theme.Product = function () {

  var useSideCart = false;

  /**
   * Scripts run on the product template
   * @param       {HTMLElement} container The product container
   * @constructor
   */

  function Product(container) {
    this.container = container;
    // We need to use jQuery here for slate.variants
    this.$container = $(container);

    this.cartSettings = container.dataset.cartSettings;
    if (this.cartSettings === 'overlay' || this.cartSettings === 'offcanvas') {
      useSideCart = true;
    }

    // Pickup the product data
    var jsonContainer = this.container.querySelector('[data-product-json]');
    this.data = JSON.parse(jsonContainer.innerText);

    // Setup variant selector with slate
    var options = {
      $container: this.$container,
      enableHistoryState: this.container.dataset.enableHistoryState || false,
      singleOptionSelector: '[data-single-option-selector]',
      originalSelectorId: '[data-product-select]',
      product: this.data
    };

    this.variants = new slate.Variants(options);
    this.$container.on('variantChange', this.onVariantChanged.bind(this));

    // The add to cart listener
    this.addButton = this.container.querySelector('.product__add');
    this.addButton.addEventListener('click', this.addClickHandler.bind(this));

    this.initImageCarousels();
    this.initRelatedProducts();

    document.querySelectorAll('.product .animate-start').forEach(function (el) {
      el.classList.remove('animate-start');
      el.classList.add('animate-finish');
    });
  }

  /**
   * The variant change handler
   */
  Product.prototype.onVariantChanged = function (event) {
    var variant = event.variant;

    this.container.querySelector('[data-product-price]').innerText = slate.Currency.formatMoney(variant.price);

    if (variant.available) {
      this.addButton.removeAttribute('disabled');
      this.addButton.querySelector('span').innerText = theme.strings.addToCart;
    } else {
      this.addButton.setAttribute('disabled', 'disabled');
      this.addButton.querySelector('span').innerText = theme.strings.soldOut;
    }
  };

  /**
   * The add to cart button click handler
   */
  Product.prototype.addClickHandler = function (event) {
    event.preventDefault();

    this.addButton.classList.add('btn--loading');

    var form = this.container.querySelector('.product__form');

    var variant = this.variants.currentVariant;
    var product = this.variants.product; /* eslint-disable-line */
    var description = variant.title;

    var max = 999;
    if (variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny') {
      max = variant.inventory_quantity;
    }

    // Gather the data of the item
    var item = {
      id: Number(form.id.value),
      quantity: Number(form.quantity.value),
      price: Number(variant.price),
      title: this.variants.product.title,
      description: description,
      url: this.data.url + '?variant=' + variant.id,
      image: variant.featured_image || this.data.images[0],
      min: 0,
      max: max
    };

    // Look for form items with a name starting with "properties"
    var properties = {};
    var propertyInputs = document.querySelectorAll('[name*="properties"]');
    var length = propertyInputs.length;

    // Push all the found properties into an object
    for (var i = 0; i < length; i++) {
      if (propertyInputs[i].value) {
        var propertyName = propertyInputs[i].name;
        propertyName = propertyName.substring(11, propertyName.length - 1);
        properties[propertyName] = propertyInputs[i].value;
      }
    }

    // If there were properties, attach them to the data to send
    if (Object.keys(properties).length) {
      item.properties = properties;
    }

    // Add the item to the cart, the cart will deal with adding it to shopify
    if (useSideCart) {
      theme.sideCart.openDrawer();
    }

    theme.sideCart.addItem(item);

    this.addButton.classList.remove('btn--loading');
    this.addButton.classList.add('btn--added');
  };

  /**
   * Deal with the image carousels
   * @todo we need a better method than hiding the thumbs with css
   */
  Product.prototype.initImageCarousels = function () {

    var productImages = $('.product__images');
    var productThumbnails = $('.product__thumbnails');

    // Carousel for main image
    productImages.slick({
      accessibility: true,
      arrows: false,
      // asNavFor: productThumbnails,
      dots: false,
      lazyLoad: 'progressive',
      swipeToSlide: true,
      responsive: [{
        breakpoint: Number(theme.settings.grid_medium),
        settings: {
          arrows: false,
          dots: true
        }
      }]
    });

    // Carousel for thumbnails
    if (productThumbnails) {
      productThumbnails.slick({
        accessibility: true,
        arrows: true,
        asNavFor: productImages,
        centerMode: true,
        centerPadding: 0,
        focusOnSelect: true,
        slidesToShow: 4
      });
    }
  };

  /**
   * Deal with the related products carousel
   */
  Product.prototype.initRelatedProducts = function () {

    // Are there related products?
    var $relatedProducts = $('.related-products__container');
    if (!$relatedProducts.length) {
      return;
    }

    var isInited = false;

    // Use a carousel at mobile size, kill it otherwise
    function onResize() {
      var clientWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

      if (isInited) {
        if (clientWidth > Number(theme.settings.grid_medium)) {
          $relatedProducts.slick('unslick');
          isInited = false;
        }
      } else if (clientWidth <= Number(theme.settings.grid_medium)) {
        $relatedProducts.slick({
          centerMode: true,
          centerPadding: '6%',
          accessibility: false,
          arrows: false,
          infinite: true,
          slidesToShow: 2,
          swipeToSlide: true
        });
        isInited = true;
      }
    }

    window.addEventListener('resize', onResize);
    onResize();
  };

  return Product;
}();

theme.ProductBundle = function () {

  var useSideCart = false;

  /**
   * Scripts run on the product template
   * @param       {HTMLElement} container The product container
   * @constructor
   *
   */
  function ProductBundle(container) {

    var self = this;
    this.container = container;
    this.cartSettings = container.dataset.cartSettings;
    if (this.cartSettings === 'overlay' || this.cartSettings === 'offcanvas') {
      useSideCart = true;
    }

    this.variants = [];

    // Pickup the product data
    var jsonContainer = this.container.querySelector('[data-product-json]');
    this.data = JSON.parse(jsonContainer.innerText);

    this.form = this.container.querySelector('.product__form');
    this.items = this.form.querySelectorAll('[data-item]');

    var itemsSelector = this.container.querySelectorAll('[data-product-select]');
    if (itemsSelector) {
      itemsSelector.forEach(function (itemSelector) {
        itemSelector.addEventListener('change', function () {
          var selectedVariant = itemSelector.options[itemSelector.selectedIndex].value;
          itemSelector.setAttribute('data-selected-variant', selectedVariant);
        });
      });
    }

    this.items.forEach(function (item) {
      // We need to use jQuery here for slate.variants
      var $item = $(item);
      var itemJsonContainer = item.querySelector('[data-item-json]');
      var itemData = JSON.parse(itemJsonContainer.innerText);

      // Setup variant selector with slate
      var options = {
        $container: $item,
        enableHistoryState: false,
        singleOptionSelector: '[data-single-option-selector]',
        originalSelectorId: '[data-product-select]',
        product: itemData
      };

      self.variants.push(new slate.Variants(options));

      $item.on('variantPriceChange', self.onVariantPriceChanged.bind(self));
      self.onVariantPriceChanged();
    });

    // The add to cart listener
    this.addButton = this.container.querySelector('.product__add');
    this.addButton.addEventListener('click', this.addClickHandler.bind(this));

    this.initImageCarousels();
    this.initRelatedProducts();

    document.querySelectorAll('.product .animate-start').forEach(function (el) {
      el.classList.remove('animate-start');
      el.classList.add('animate-finish');
    });
  }

  /**
   * The variant change handler
   */
  ProductBundle.prototype.onVariantPriceChanged = function (event) {

    var self = this;
    // Need to set a timeout because the currentVariant doesn't update immediately
    setTimeout(function () {
      if (event) {
        var variant = event.variant;

        // Update the price of the changed variant
        var price = event.currentTarget.querySelector('[data-product-price]');
        price.innerText = slate.Currency.formatMoney(variant.price);
      }

      // Add up the total of all variants
      var length = self.variants.length;
      var total = 0;

      for (var i = 0; i < length; i++) {
        total += self.variants[i].currentVariant.price;
      }

      var totalPrice = self.container.querySelector('.product__price [data-product-price]');
      totalPrice.innerText = slate.Currency.formatMoney(total);
    }, 200);
  };

  /**
   * The add to cart button click handler
   *
   */
  ProductBundle.prototype.addClickHandler = function (event) {
    var _this4 = this;

    event.preventDefault();
    this.addButton.classList.add('btn--loading');

    var length = this.variants.length;

    var allBundleProds = this.container.querySelectorAll('[data-product-select]');

    var _loop = function _loop(i) {
      var variant = _this4.variants[i].currentVariant;
      var product = _this4.variants[i].product;
      var item = {};
      var sizeIndex = product.options.indexOf('Size');
      var size = variant['option' + (sizeIndex + 1)];
      var description = 'Size: ' + size;
      var max = 999;
      /* eslint-disable */
      allBundleProds.forEach(function (prodBundle) {
        var productId = parseInt(prodBundle.getAttribute('data-product-id'), 10);
        var variantId = parseInt(prodBundle.getAttribute('data-selected-variant'), 10);
        if (productId === product.id) {
          if (product.variants.length > 0) {
            product.variants.forEach(function (prodVariant) {
              if (prodVariant.id === variantId) {
                if (prodVariant.inventory_management === 'shopify' && prodVariant.inventory_policy === 'deny') {
                  max = prodVariant.inventory_quantity;
                }
                item = {
                  id: variantId,
                  quantity: 1,
                  price: prodVariant.price,
                  title: product.title,
                  description: prodVariant.title,
                  url: _this4.data.url,
                  image: product.featured_image,
                  min: 0,
                  max: max
                };
              }
            }); /* eslint-enable */
          } else {
            if (variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny') {
              max = variant.inventory_quantity;
            }
            // Gather the data of the item
            item = {
              id: variant.id,
              quantity: 1,
              price: variant.price,
              title: product.title,
              description: description,
              url: _this4.data.url,
              image: product.featured_image,
              min: 0,
              max: max
            };
          }
        }
      });
      // Add the item to the cart, the cart will deal with adding it to shopify
      theme.sideCart.addItem(item);
    };

    for (var i = 0; i < length; i++) {
      _loop(i);
    }

    if (useSideCart) {
      theme.sideCart.openDrawer();
    }

    this.addButton.classList.remove('btn--loading');
    this.addButton.classList.add('btn--added');
  };

  /**
   * Deal with the image carousels
   */
  ProductBundle.prototype.initImageCarousels = function () {

    var productImages = $('.product__images');
    var productThumbnails = $('.product__thumbnails');

    // Carousel for main image
    productImages.slick({
      accessibility: true,
      arrows: false,
      // asNavFor: productThumbnails,
      dots: false,
      lazyLoad: 'progressive',
      swipeToSlide: true,
      responsive: [{
        breakpoint: Number(theme.settings.grid_medium),
        settings: {
          arrows: false,
          dots: true
        }
      }]
    });

    // Carousel for thumbnails
    if (productThumbnails) {
      productThumbnails.slick({
        accessibility: true,
        arrows: true,
        asNavFor: productImages,
        centerMode: false,
        centerPadding: 0,
        focusOnSelect: true,
        slidesToShow: 4
      });
    }
  };

  /**
   * Deal with the related products carousel
   */
  ProductBundle.prototype.initRelatedProducts = function () {

    // Are there related products?
    var $relatedProducts = $('.related-products__container');
    if (!$relatedProducts.length) {
      return;
    }

    var isInited = false;

    // Use a carousel at mobile size, kill it otherwise
    function onResize() {
      var clientWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

      if (isInited) {
        if (clientWidth > Number(theme.settings.grid_medium)) {
          $relatedProducts.slick('unslick');
          isInited = false;
        }
      } else if (clientWidth <= Number(theme.settings.grid_medium)) {
        $relatedProducts.slick({
          centerMode: true,
          centerPadding: '6%',
          accessibility: false,
          arrows: false,
          infinite: true,
          slidesToShow: 2,
          swipeToSlide: true
        });
        isInited = true;
      }
    }

    window.addEventListener('resize', onResize);
    onResize();
  };

  return ProductBundle;
}();

theme.ProductBundleAcc = function () {

  var useSideCart = false;

  /**
   * Scripts run on the product template
   * @param       {HTMLElement} container The product container
   * @constructor
   */

  function ProductBundleAcc(container) {
    this.container = container;
    // We need to use jQuery here for slate.variants
    this.$container = $(container);
    this.cartSettings = container.dataset.cartSettings;
    if (this.cartSettings === 'overlay' || this.cartSettings === 'offcanvas') {
      useSideCart = true;
    }

    // Pickup the product data
    var jsonContainer = this.container.querySelector('[data-product-json]');
    this.data = JSON.parse(jsonContainer.innerText);

    // Setup variant selector with slate
    var options = {
      $container: this.$container,
      enableHistoryState: this.container.dataset.enableHistoryState || false,
      singleOptionSelector: '[data-single-option-selector]',
      originalSelectorId: '[data-product-select]',
      product: this.data
    };

    this.variants = new slate.Variants(options);
    this.$container.on('variantChange', this.onVariantChanged.bind(this));

    var itemsSelector = this.container.querySelectorAll('[data-product-acc-select]');
    if (itemsSelector) {
      itemsSelector.forEach(function (itemSelector) {
        itemSelector.addEventListener('change', function () {
          var selectedVariant = itemSelector.options[itemSelector.selectedIndex].value;
          itemSelector.setAttribute('data-selected-variant', selectedVariant);
        });
      });
    }

    // The add to cart listener
    this.addButton = this.container.querySelector('.product__add');
    this.addButton.addEventListener('click', this.addClickHandler.bind(this));

    this.initImageCarousels();
    this.initRelatedProducts();

    document.querySelectorAll('.product .animate-start').forEach(function (el) {
      el.classList.remove('animate-start');
      el.classList.add('animate-finish');
    });
  }

  /**
   * The variant change handler
   */
  ProductBundleAcc.prototype.onVariantChanged = function (event) {
    var variant = event.variant;

    this.container.querySelector('[data-product-price]').innerText = slate.Currency.formatMoney(variant.price);

    if (variant.available) {
      this.addButton.removeAttribute('disabled');
      this.addButton.querySelector('span').innerText = theme.strings.addToCart;
    } else {
      this.addButton.setAttribute('disabled', 'disabled');
      this.addButton.querySelector('span').innerText = theme.strings.soldOut;
    }
  };

  /**
   * The add to cart button click handler
   */
  ProductBundleAcc.prototype.addClickHandler = function (event) {
    event.preventDefault();

    this.addButton.classList.add('btn--loading');

    var form = this.container.querySelector('.product__form');

    var variant = this.variants.currentVariant;
    var product = this.variants.product;

    var sizeIndex = product.options.indexOf('Size');
    var size = variant['option' + (sizeIndex + 1)];
    var description = 'Size: ' + size;

    var max = 999;
    if (variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny') {
      max = variant.inventory_quantity;
    }

    // Gather the data of the item
    var item = {
      id: Number(form.id.value),
      quantity: Number(form.quantity.value),
      price: Number(variant.price),
      title: this.variants.product.title,
      description: description,
      url: this.data.url + '?variant=' + variant.id,
      image: variant.featured_image || this.data.images[0],
      min: 0,
      max: max
    };

    // Look for form items with a name starting with "properties"
    var properties = {};
    var propertyInputs = document.querySelectorAll('[name*="properties"]');
    var length = propertyInputs.length;

    // Push all the found properties into an object
    for (var i = 0; i < length; i++) {
      if (propertyInputs[i].value) {
        var propertyName = propertyInputs[i].name;
        propertyName = propertyName.substring(11, propertyName.length - 1);
        properties[propertyName] = propertyInputs[i].value;
      }
    }

    // If there were properties, attach them to the data to send
    if (Object.keys(properties).length) {
      item.properties = properties;
    }

    // Add the item to the cart, the cart will deal with adding it to shopify
    if (useSideCart) {
      theme.sideCart.openDrawer();
    }
    theme.sideCart.addItem(item);

    var chkAcc = this.container.querySelector('[data-add-acc]');
    if (chkAcc && chkAcc.checked) {
      var accJsonContainer = this.container.querySelector('[data-item-acc-json]');
      this.data = JSON.parse(accJsonContainer.innerText);

      // Setup variant selector with slate
      var options = {
        $container: this.$container,
        enableHistoryState: this.container.dataset.enableHistoryState || false,
        singleOptionSelector: '[data-product-acc-select]',
        originalSelectorId: '[data-product-acc-select]',
        product: this.data
      };

      this.variants = new slate.Variants(options);
      var prodAcc = this.container.querySelector('[data-product-acc-select]');
      var variantId = parseInt(prodAcc.getAttribute('data-selected-variant'), 10);
      product = this.variants.product;
      variant = product.variants.filter(function (prodVariant) {
        return prodVariant.id === variantId;
      });

      // sizeIndex = product.options.indexOf('Size');
      // size = variant['option' + (sizeIndex + 1)];
      description = variant.title;

      max = 999;
      if (variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny') {
        max = variant.inventory_quantity;
      }

      // Gather the data of the item
      item = {
        id: variantId,
        quantity: 1,
        price: Number(variant.price),
        title: this.variants.product.title,
        description: description,
        url: this.data.url + '?variant=' + variantId,
        image: variant.featured_image || this.data.images[0],
        min: 0,
        max: max
      };
      theme.sideCart.addItem(item);
    }

    this.addButton.classList.remove('btn--loading');
    this.addButton.classList.add('btn--added');
  };

  /**
   * Deal with the image carousels
   * @todo we need a better method than hiding the thumbs with css
   */

  ProductBundleAcc.prototype.initImageCarousels = function () {

    var productImages = $('.product__images');
    var productThumbnails = $('.product__thumbnails');

    // Carousel for main image
    productImages.slick({
      accessibility: true,
      arrows: false,
      // asNavFor: productThumbnails,
      dots: false,
      lazyLoad: 'progressive',
      swipeToSlide: true,
      responsive: [{
        breakpoint: Number(theme.settings.grid_medium),
        settings: {
          arrows: false,
          dots: true
        }
      }]
    });

    // Carousel for thumbnails
    if (productThumbnails) {
      productThumbnails.slick({
        accessibility: true,
        arrows: true,
        asNavFor: productImages,
        centerMode: false,
        centerPadding: 0,
        focusOnSelect: true,
        slidesToShow: 4
      });
    }
  };

  /**
   * Deal with the related products carousel
   */
  ProductBundleAcc.prototype.initRelatedProducts = function () {

    // Are there related products?
    var $relatedProducts = $('.related-products__container');
    if (!$relatedProducts.length) {
      return;
    }

    var isInited = false;

    // Use a carousel at mobile size, kill it otherwise
    function onResize() {
      var clientWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

      if (isInited) {
        if (clientWidth > Number(theme.settings.grid_medium)) {
          $relatedProducts.slick('unslick');
          isInited = false;
        }
      } else if (clientWidth <= Number(theme.settings.grid_medium)) {
        $relatedProducts.slick({
          centerMode: true,
          centerPadding: '6%',
          accessibility: false,
          arrows: false,
          infinite: true,
          slidesToShow: 2,
          swipeToSlide: true
        });
        isInited = true;
      }
    }

    window.addEventListener('resize', onResize);
    onResize();
  };

  return ProductBundleAcc;
}();

theme.BannerSlider = function () {

  /**
   * Constructor
   */
  function BannerSlider(container) {

    this.settings = container.dataset.sectionSettings || '{}';
    this.$slider = $(container).find('.banner-slider');

    // Parse the settings string passed through from liquid
    var userSettings = JSON.parse(this.settings);

    // Create some defaults
    var defaultSettings = {
      infinite: true,
      autoplaySpeed: userSettings.slide_speed,
      speed: userSettings.slide_speed / 2,
      responsive: [{
        breakpoint: window.theme.settings.grid_medium || 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    };

    // Merge the objects - userSettings will have precedence
    var sliderSettings = $.extend(defaultSettings, userSettings);
    // Init slick carousel
    this.$slider.slick(sliderSettings);
  }

  /**
   * Shopify section event handler
   */
  BannerSlider.prototype.onBlockSelect = function (event) {
    // Go to the currently selected block in slick carousel and pause
    var index = parseInt(event.target.dataset.slickIndex, 10);
    this.$slider.slick('slickGoTo', index).slick('slickPause');
  };

  /**
   * Shopify section event handler
   */
  BannerSlider.prototype.onBlockDeselect = function () {
    // Resume carousel
    this.$slider.slick('slickPlay');
  };

  return BannerSlider;
}();

theme.HeroSlider = function () {

  /**
   * Constructor
   */
  function HeroSlider(container) {

    this.settings = container.dataset.sectionSettings || '{}';
    this.$slider = $(container).find('.hero-slider');

    // Parse the settings string passed through from liquid
    var userSettings = JSON.parse(this.settings);

    // Create some defaults
    var defaultSettings = {
      infinite: true,
      autoplaySpeed: userSettings.slide_speed,
      speed: userSettings.slide_speed / 2,
      responsive: [{
        breakpoint: window.theme.settings.grid_medium || 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    };

    // Merge the objects - userSettings will have precedence
    var sliderSettings = $.extend(defaultSettings, userSettings);
    // Init slick carousel
    this.$slider.slick(sliderSettings);
  }

  /**
   * Event handler that updates the fade setting based on slidesToShow
   */
  HeroSlider.prototype.slideHandler = function (event) {

    if (event.target.name.indexOf('slidesToShow') === -1) {
      return;
    }

    var fade = window.top.document.querySelector('[id$=fade]');

    if (event.target.value > 1) {
      fade.checked = false;
      fade.disabled = true;
    } else {
      fade.checked = true;
      fade.disabled = false;
    }
  };

  /**
   * Shopify section event handler
   */
  HeroSlider.prototype.onSelect = function () {
    window.top.addEventListener('input', this.slideHandler.bind(this));
    window.top.addEventListener('change', this.slideHandler.bind(this));
  };

  /**
   * Shopify section event handler
   */
  HeroSlider.prototype.onDeselect = function () {
    window.top.removeEventListener('input', this.slideHandler.bind(this));
    window.top.removeEventListener('change', this.slideHandler.bind(this));
  };

  /**
   * Shopify section event handler
   */
  HeroSlider.prototype.onBlockSelect = function (event) {
    // Go to the currently selected block in slick carousel and pause
    var index = parseInt(event.target.dataset.slickIndex, 10);
    this.$slider.slick('slickGoTo', index).slick('slickPause');
  };

  /**
   * Shopify section event handler
   */
  HeroSlider.prototype.onBlockDeselect = function () {
    // Resume carousel
    this.$slider.slick('slickPlay');
  };

  return HeroSlider;
}();

theme.Testimonials = function () {

  /**
   * Constructor
   */
  function Testimonials(container) {

    this.settings = container.dataset.sectionSettings || '{}';
    this.$slider = $(container).find('.slider');

    // Parse the settings string passed through from liquid
    var userSettings = JSON.parse(this.settings);

    // Create some defaults
    var defaultSettings = {
      infinite: true,
      autoplaySpeed: userSettings.slide_speed,
      speed: userSettings.slide_speed / 2,
      responsive: [{
        breakpoint: window.theme.settings.grid_medium || 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    };

    // Merge the objects - userSettings will have precedence
    var sliderSettings = $.extend(defaultSettings, userSettings);
    // Init slick carousel
    this.$slider.slick(sliderSettings);
  }

  /**
  * Event handler that updates the fade setting based on slidesToShow
  */
  function slideHandler(evt) {
    if (!evt.target.name.indexOf('slidesToShow')) {
      return;
    }
    if (evt.target.name.indexOf('slidesToShow')) {
      var fade = window.top.document.querySelector('[id="fade"]');

      if (evt.target.value > 1) {
        fade.checked = false;
        fade.disabled = true;
      } else {
        fade.checked = true;
        fade.disabled = false;
      }
    }
  }

  /**
   * Shopify section methods
   */
  Testimonials.prototype = $.extend({}, Testimonials.prototype, {

    onSelect: function onSelect() {
      window.top.addEventListener('input', slideHandler);
      window.top.addEventListener('change', slideHandler);
    },

    onDeselect: function onDeselect() {
      window.top.removeEventListener('input', slideHandler);
      window.top.removeEventListener('change', slideHandler);
    },

    onBlockSelect: function onBlockSelect(evt) {
      // Go to the currently selected block in slick carousel and pause
      var index = parseInt(evt.target.dataset.slickIndex, 10);
      this.$slider.slick('slickGoTo', index).slick('slickPause');
    },

    onBlockDeselect: function onBlockDeselect() {
      // Resume carousel
      this.$slider.slick('slickPlay');
    }

  });

  return Testimonials;
}();

theme.InlineVideo = function () {

  function InlineVideo(container) {

    var video = container.querySelector('video');
    var playButton = container.querySelector('[data-video="play"]');
    var posterInfo = container.querySelector('.inline-video__info');
    var posterImage = container.querySelector('.inline-video__image');

    video.removeAttribute('controls');

    playButton.addEventListener('click', function (event) {
      event.preventDefault();

      posterInfo.classList.add('is-hidden');
      posterImage.classList.add('is-hidden');

      video.play();
    });

    video.addEventListener('ended', function () {
      posterInfo.classList.remove('is-hidden');
      posterImage.classList.remove('is-hidden');
    });
  }

  return InlineVideo;
}();

theme.featuredCollections = function () {
  // Function to kick in Slick slider for mobile
  //  on featured collection product cards.

  // Note: .not('slick-initialized') is to stop
  //  double firing on initialize when resizing.

  function featuredCollections() {
    // Global Variables
    var isInited = false;
    var slickContainer = $('.featured-collections__slider');

    function onResize() {
      var clientWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

      if (isInited) {
        if (clientWidth >= Number(theme.settings.grid_medium)) {
          $(slickContainer).slick('unslick');
          isInited = false;
        }
      } else if (clientWidth < Number(theme.settings.grid_medium)) {
        $(slickContainer).slick({
          arrows: false,
          dots: true,
          infinite: false,
          centerMode: true,
          centerPadding: '6%'
        });
        isInited = true;
      }
    }

    window.addEventListener('resize', onResize);
    onResize();
  }

  return featuredCollections;
}();

theme.featuredCollection = function () {
  // Function to kick in Slick slider for mobile
  //  on featured collection product cards.

  // Note: .not('slick-initialized') is to stop
  //  double firing on initialize when resizing.

  function featuredCollection() {
    // Global Variables
    // let isInited = false;
    var slickContainer = $('.featured-slider');

    $(slickContainer).slick({
      accessibility: false,
      mobileFirst: true,
      centerMode: true,
      centerPadding: '6%',
      arrows: false,
      dots: false,
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: Number(theme.settings.grid_small),
        settings: {
          centerMode: true,
          arrows: false,
          slidesToShow: 2
        }
      }, {
        breakpoint: Number(theme.settings.grid_medium),
        settings: {
          centerMode: true,
          arrows: true,
          slidesToShow: 3
        }
      }, {
        breakpoint: Number(theme.settings.grid_large),
        settings: {
          centerMode: false,
          arrows: true,
          slidesToShow: 5
        }
      }]
    });
  }

  return featuredCollection;
}();

// ===============require sections/instagram.js


// Templates
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */
/* eslint-disable */
theme.customerAddresses = function () {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function () {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function () {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function () {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function () {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
    }
  });
}();
/* eslint-enable */

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = function () {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
}();

theme.Blog = function () {

  function Blog() {

    var selectDropdown = document.getElementById('article-select');

    selectDropdown.addEventListener('change', function () {
      window.location = '/blogs/news/tagged/' + this.value;
    });
  }

  return Blog;
}();

$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register('header', theme.Header);
  sections.register('product', theme.Product);
  sections.register('product-bundle', theme.ProductBundle);
  sections.register('product-bundle-acc', theme.ProductBundleAcc);
  sections.register('banner-slider', theme.BanerSlider);
  sections.register('hero-slider', theme.HeroSlider);
  sections.register('testimonials', theme.Testimonials);
  sections.register('inline-video', theme.InlineVideo);
  sections.register('featured-collections', theme.featuredCollections);
  sections.register('featured-collection', theme.featuredCollection);
  sections.register('featured-articles', theme.featuredArticles);
  sections.register('featured-articles', theme.featuredArticles);
  // sections.register('instagram', theme.Instagram);

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Instantiate components automatically
  document.querySelectorAll('[data-component]').forEach(function (el) {
    if (theme[el.dataset.component]) {
      new theme[el.dataset.component](el);
    } else {
      console.error(el.dataset.component, 'component is not defined.');
    }
  });

  // Instantiate templates automatically
  document.querySelectorAll('[data-template]').forEach(function (el) {
    if (theme[el.dataset.template]) {
      new theme[el.dataset.template](el);
    } else {
      console.error(el.dataset.template, 'template is not defined.');
    }
  });

  // Instantiate the dialog modals
  var mainContent = document.querySelector('#MainContent');
  document.querySelectorAll('[data-dialog]').forEach(function (el) {
    var dialog = new window.A11yDialog(el, mainContent);
    dialog.container.classList.remove('hidden');
  });

  // Instantiate scroll trigger for items marked data-scroll
  new ScrollTrigger({
    toggle: {
      visible: 'animate-finish',
      hidden: 'animate-start'
    },
    offset: {
      x: 0,
      y: window.innerHeight / 4
    },
    once: true
  });

  window.lazySizesConfig = window.lazySizesConfig || {};
  window.lazySizesConfig.loadMode = 1;
});